/** Marker embedded by backend on exchange surcharge payment notes. */
export const EXCHANGE_PAYMENT_NOTE_PREFIX = 'exchangeId:';

/**
 * Payment notes safe for UI: strips internal exchangeId markers, keeps any
 * human-written note that may follow ("exchangeId:EXCH-… | nota").
 */
export function getDisplayablePaymentNotes(notes?: string | null): string | undefined {
  if (notes == null) {
    return undefined;
  }

  const cleaned = notes
    .split('\n')
    .map((line) => {
      const trimmed = line.trim();
      if (trimmed.length === 0) {
        return '';
      }

      if (!trimmed.startsWith(EXCHANGE_PAYMENT_NOTE_PREFIX)) {
        return trimmed;
      }

      const afterPrefix = trimmed.slice(EXCHANGE_PAYMENT_NOTE_PREFIX.length);
      const pipeIdx = afterPrefix.indexOf('|');
      if (pipeIdx < 0) {
        return '';
      }

      return afterPrefix.slice(pipeIdx + 1).trim();
    })
    .filter((line) => line.length > 0)
    .join('\n')
    .trim();

  return cleaned.length > 0 ? cleaned : undefined;
}
